import React, { useEffect, useState } from "react";
import { formatPhone } from "../Utils/localStroge";
import { useDispatch, useSelector } from "react-redux";
import {
  addFavorite,
  removeFavorite,
} from "../Redux/Action/BusinessAction/businesAction";
import { Navigate, useNavigate } from "react-router";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
const WHITE_HEART = "../images/white-heart.png";
const RED_HEART = "../images/favorite_Image.png";

const linearGradientBackgrounds = [
  "linear-gradient(135deg, #FF4081, #7C4DFF)",

  "linear-gradient(to right, #8BC34A, #009688)",

  "linear-gradient(to right, #7595FF, #FF8C8C)",

  "linear-gradient(135deg, #4A90E2, #B06AB3)",
  "linear-gradient(to right, #46CE8A, #004170)",
  "linear-gradient(to right, #CEC346, #702E00)",
];

const Card = ({
  width = 350,
  height = 415,
  marginLeft = 0,
  marginBottom = 20,
  data,
  handleViewDetail,
  showReview = false,
  showAddress = false,
  gridView = false,
  showPhone = false,
  onFavoriteUpdate,
  cardIndex = 0, // For cycling gradients
}) => {
  const [isFavorite, setIsFavorite] = useState(data?.isFavourite || false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginDataSuccess } = useSelector((state) => state.LoginData);
  const accessToken = loginDataSuccess?.access_token;

  useEffect(() => {
    setIsFavorite(data?.isFavourite || false);
  }, [data?.isFavourite]);

  const handleFavoriteClick = async (e) => {
    e.stopPropagation();
    if (!accessToken) {
      navigate("/signin");
      return;
    }
    if (loading) return;
    setLoading(true);
    try {
      const response = await dispatch(
        isFavorite
          ? removeFavorite({ business_id: data.id })
          : addFavorite({ business_id: data.id })
      );
      if (response?.payload?.status === 409) {
        toast.info(
          isFavorite
            ? "Business is already deleted successfully"
            : "Business is already added to favorites"
        );
        return;
      }
      if (
        response.type === "ADD_FAVORITE_SUCCESS" ||
        response.type === "REMOVE_FAVORITE_SUCCESS"
      ) {
        setIsFavorite(!isFavorite);
        if (onFavoriteUpdate) {
          onFavoriteUpdate(data.id);
        }
        toast.success(
          isFavorite
            ? "Business removed from favorites successfully"
            : "Business added to favorites successfully"
        );
      }
    } catch (error) {
      console.error("Error handling favorite:", error);
    } finally {
      setLoading(false);
    }
  };

  const {
    address1,
    city,
    state,
    country,
    zipcode,
    is_address_hide,
    phone,
    country_code,
    lat,
    lng,
    busi_type_id,
  } = data;
  var text = address1 || "";
  var count = 8;
  var result = text?.slice(0, count) + (text.length > count ? "..." : "");

  const hasImage = data?.businessImage?.[0]?.image;
  const imageContainerHeight = "155px";

  const defaultBgStyle = {
    width: "100%",
    height: imageContainerHeight,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    fontSize: "1.2rem",
    fontWeight: "bold",
    padding: "10px",
    boxSizing: "border-box",
    background:
      linearGradientBackgrounds[cardIndex % linearGradientBackgrounds.length],
  };

  const lockTriangleSize = "50px";
  const lockIconSize = "18px";
  const lockIconTopOffset = `-${parseInt(lockTriangleSize) * 0.85}px`;
  const lockIconRightOffset = "3px";

  return (
    <div
      className="nib-box"
      style={{
        width,
        minWidth: width,
        height,
        marginLeft,
        marginBottom,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
        boxSizing: "border-box",
        padding: "10px",
        borderRadius: "8px",
      }}
    >
      <div style={{ flex: 1 }}>
        {/* Image/Gradient Area Wrapper */}
        <div
          className="imageAreaWrapper"
          style={{
            width: "100%",
            height: imageContainerHeight,
            borderRadius: "8px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {hasImage ? (
            <img
              src={data?.businessImage?.[0]?.image}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              alt={data?.business_name || "Business"}
            />
          ) : (
            <div style={defaultBgStyle}>{data?.business_name}</div>
          )}

          {data?.userDetail?.subscription_id === 1 && (
            <>
              <div
                className="lockTriangle"
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  width: "0",
                  height: "0",
                  borderTop: `${lockTriangleSize} solid #000000ab`,
                  borderLeft: `${lockTriangleSize} solid transparent`,
                  zIndex: 1,
                }}
              >
                <img
                  src="../images/greenlock.png"
                  style={{
                    position: "absolute",
                    top: lockIconTopOffset,
                    right: lockIconRightOffset,
                    width: lockIconSize,
                    height: lockIconSize,
                  }}
                  alt="Premium"
                />
              </div>

              <button
                onClick={handleFavoriteClick}
                disabled={loading}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  zIndex: 2,
                  width: "24px",
                  height: "24px",
                }}
              >
                <img
                  src={isFavorite ? RED_HEART : WHITE_HEART}
                  alt={isFavorite ? "Favorited" : "Not favorited"}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    marginLeft: "-25px",
                  }}
                />
              </button>
            </>
          )}

          {data?.userDetail?.subscription_id !== 1 && (
            <button
              onClick={handleFavoriteClick}
              disabled={loading}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: 0,
                zIndex: 2,
                width: "24px",
                height: "24px",
              }}
            >
              <img
                src={isFavorite ? RED_HEART : WHITE_HEART}
                alt={isFavorite ? "Favorited" : "Not favorited"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </button>
          )}

          {busi_type_id === 6 && (
            <label
              style={{
                position: "absolute",
                transform: "translate(-50%, -50%)",
                top: "92%",
                left: "50%",
                backgroundColor: "#00000094",
                color: "white",
                // width: `calc(${width}px - 20px)`,
                width: "100%",
                textAlign: "center",
                fontSize: "1.1rem",
              }}
            >
              Gig worker
            </label>
          )}
        </div>{" "}
        <h4 style={{ textAlign: "left", margin: "10px 0" }}>
          {data?.business_name}
        </h4>
        {showReview && (
          <ul style={{ padding: 0, margin: "10px 0" }}>
            {Array.from(
              { length: parseInt(data?.reviewAverage || 0) },
              (_, i) => (
                <li
                  key={i}
                  style={{ display: "inline-block", marginRight: "5px" }}
                >
                  <i className={`fa-solid fa-star`} />
                </li>
              )
            )}
          </ul>
        )}
        {showAddress && is_address_hide !== 2 && (
          <div
            className="d-flex align-items-baseline"
            style={{
              margin: "10px 0",
              height: "60px",
              lineHeight: "20px",
              overflow: "hidden",
            }}
          >
            <i
              className="fa-solid fa-location-dot"
              style={{ color: "#349c52", marginRight: "5px", fontSize: "15px" }}
            />
            <p
              style={{
                color: "#ffffffc9",
                fontSize: "14px",
                fontWeight: 500,
                textAlign: "initial",
                margin: 0,
                cursor: "pointer",
              }}
              onClick={() => {
                window.open(
                  `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
                  "_"
                );
              }}
            >
              {address1}, {city}, {state}, {country}, {zipcode}
            </p>
          </div>
        )}
        {showPhone && phone && (
          <div
            className="d-flex align-items-baseline"
            style={{ margin: "10px 0" }}
          >
            <a
              href={`tel:${country_code}${phone}`}
              style={{ textDecoration: "none", color: "#dadada" }}
            >
              <img
                src="../images/call-calling.svg"
                width="18px"
                height="18px"
                alt=""
              />{" "}
              {formatPhone(`${country_code}${phone}`)}
            </a>
          </div>
        )}
      </div>
      {data?.userDetail?.subscription_id === 1 ? (
        <button
          className="view-detail-btn"
          style={{ width: "100%", padding: "10px", marginTop: "10px" }}
          onClick={() => {
            window.open(`tel:${country_code}${phone}`, "_self");
          }}
        >
          Call Now
        </button>
      ) : (
        <Link
          className="view-detail-btn"
          to={`/businessDetails/${data?.id}?name=${data.business_name?.trim()?.replaceAll(" ", "_")}&cardIndex=${cardIndex}`}
          style={{ width: "100%", padding: "10px", marginTop: "10px", textDecoration: 'none', textAlign: 'center' }}
        >
          View Details
        </Link>
      )}
    </div>
  );
};

export default Card;
